import styled from 'styled-components'

export const ContentWrapper = styled.main`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 1.5rem;
  margin-top: 2rem;
`
